var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "01 Icons/01 Small/ic-bell") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.125953 0 0 0 0 0.755859 0 0 0 0 0.381231 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "01-Icons/01-Small/ic-bell",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-1)",
    id: 1827349
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1058905,9.59999943 C18.6122562,9.59999943 18.2117821,9.2110105 18.2117821,8.73153315 C18.2117821,6.29534298 17.2353195,4.00593813 15.4621656,2.28268222 C15.1126103,1.94315187 15.1126103,1.39433717 15.4621656,1.05464775 C15.8117208,0.715117353 16.3769034,0.715117353 16.7264587,1.05464775 C18.837707,3.10518866 19.9999988,5.83160971 19.9999988,8.73153315 C19.9999988,9.2110105 19.5995247,9.59999943 19.1058905,9.59999943 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.894085481,9.59999943 C0.400627587,9.59999943 0,9.2110105 0,8.73153315 C0,5.83160971 1.16242574,3.10518866 3.27345636,1.05464775 C3.62300271,0.715117353 4.18817083,0.715117353 4.53771717,1.05464775 C4.88742723,1.39433717 4.88742723,1.94315187 4.53771717,2.28268222 C2.76460863,4.00498392 1.78833472,6.29534298 1.78833472,8.73153315 C1.78833472,9.2110105 1.38770713,9.59999943 0.894085481,9.59999943 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6287628,14.8834693 C17.237649,13.7587658 16.4400074,12.1148939 16.4400074,10.3733759 L16.4400074,7.91997535 C16.4400074,4.82333462 14.0351224,2.25988065 10.9200246,1.83046305 L10.9200246,0.87994354 C10.9200246,0.393323961 10.5078115,0 10.0000836,0 C9.49218727,0 9.07997419,0.393323961 9.07997419,0.87994354 L9.07997419,1.83046305 C5.96403419,2.25988065 3.55999136,4.82333462 3.55999136,7.91997535 L3.55999136,10.3733759 C3.55999136,12.1148939 2.76234983,13.7587658 1.36315007,14.890398 C1.00518,15.1834977 0.799999952,15.6093704 0.799999952,16.0598963 C0.799999952,16.9092247 1.52217301,17.599999 2.41010727,17.599999 L17.59006,17.599999 C18.4778258,17.599999 19.1999989,16.9092247 19.1999989,16.0598963 C19.1999989,15.6093704 18.9948189,15.1834977 18.6287628,14.8834693 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3999994,21.5999987 C11.9772731,21.5999987 13.2968245,20.5671374 13.5999992,19.1999989 L7.19999957,19.1999989 C7.50301479,20.5671374 8.82256615,21.5999987 10.3999994,21.5999987 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBell);
export default __webpack_public_path__ + "static/media/ic-bell.24edd47707364de33d0be49b547228cf.svg";
export { ForwardRef as ReactComponent };